<template lang="pug">
  DefaultLayout(:topMenuItems="topMenuItems" :key="$route.params.projectId")
    router-view(:project="project")
    template(v-slot:header)
      ProjectDetail(v-if="project && showHeader" :project="project" :companyXl="companyXl")
</template>

<script>
import Access from '@/utils/access';

import DefaultLayout from '@/layouts/Default.vue';
import ProjectDetail from '@/components/ProjectDetail.vue';
import {isVisitedEnough} from '@/utils/newPage';

export default {
  name: 'ProjectDetailPage',
  components: { DefaultLayout, ProjectDetail },
  created() {
    const { projectId } = this.$route.params;
    this.$store.dispatch('project/fetchProject', { projectId, force: true });
  },
  watch: {
    project(val) {
      document.title = val.name;

      const getter = this.$store.getters['notification/itemIdsByFilter'];
      const notifications = getter({ projectId: val.id });
      notifications
        .filter(n => !n.info.taskId)
        .forEach(n => this.$store.dispatch('notification/view', n));
    },
    '$route.params.projectId': function () {
      const { projectId } = this.$route.params;
      this.$store.dispatch('project/fetchProject', { projectId, force: true });
    },
  },
  provide() {
    return { positions: this.getDepartmentMemberPositions };
  },
  methods: {
    getDepartmentMemberPositions() {
      return this.departmentMemberPositions;
    },
  },
  computed: {
    departmentMemberPositions() {
      return this.project.companyEmployeePositions;
    },
    project() { return this.$store.state.project.project; },
    showHeader() { return this.$route.meta.showProjectHeader; },
    companyXl() { return this.$route.meta.companyXl; },
    currUser() { return this.$store.state.auth.user; },
    access() { return this.project ? new Access(this.project, this.currUser) : {}; },
    err403() { return this.$store.getters['error/err403']; },
    topMenuItems() {
      if (this.err403) return null;

      const items = [];

      items.push({ admin: false,  label: 'Задачи',              to: { name: 'project-stages'                              },                                                      }); // eslint-disable-line
      items.push({ admin: false,  label: 'Диаграмма Ганта',     to: { name: 'gantt', query: { project: this.project?.id } }, blank: true,                                         }); // eslint-disable-line
      items.push({ admin: true,   label: 'Согласования',        to: { name: 'project-agreements'                          }, isNewLabel: !isVisitedEnough('agreements')           }); // eslint-disable-line
      items.push({ admin: true,   label: 'Кабинет заказчика',   to: { name: 'project-attached-files'                      }, isNewLabel: !isVisitedEnough('projectFileAttaches')  }); // eslint-disable-line
      items.push({ admin: true,   label: 'Участники',           to: { name: 'project-members'                             },                                                      }); // eslint-disable-line
      items.push({ admin: false,  label: 'Файлы',               to: { name: 'project-files'                               },                                                      }); // eslint-disable-line
      items.push({ admin: false,  label: 'Описание',            to: { name: 'project-description'                         },                                                      }); // eslint-disable-line
      items.push({ admin: false,  label: 'Гайды',               to: { name: 'guides'                                      },                                                      }); // eslint-disable-line

      const extendedAccess = this.access.isProjectAuthor?.() || this.access.isProjectAdmin?.();

      return items.filter(i => extendedAccess || !i.admin);
    },
  },
};
</script>

<style scoped lang="scss">

</style>
